/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInWebInitOutput
 */
export interface MoneyInWebInitOutput {
    /**
     * Payment Token to Pass to WebKit URL using GET
     * @type {string}
     * @memberof MoneyInWebInitOutput
     */
    webKitToken?: string;
    /**
     * Transaction ID
     * @type {number}
     * @memberof MoneyInWebInitOutput
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof MoneyInWebInitOutput
     */
    cardId?: number;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInWebInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInWebInitOutput interface.
 */
export function instanceOfMoneyInWebInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInWebInitOutputFromJSON(json: any): MoneyInWebInitOutput {
    return MoneyInWebInitOutputFromJSONTyped(json, false);
}

export function MoneyInWebInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInWebInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'webKitToken': !exists(json, 'webKitToken') ? undefined : json['webKitToken'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardId': !exists(json, 'cardId') ? undefined : json['cardId'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInWebInitOutputToJSON(value?: MoneyInWebInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'webKitToken': value.webKitToken,
        'id': value.id,
        'id ': value.id,
        'cardId': value.cardId,
        'error': value.error,
    };
}

